import apiRequest from '@/js/helpers/apiRequest';

async function get(email) {
  const DATA = await apiRequest.get('/user/check-email-domain/', {
    EMAIL: email,
  });

  if (DATA.STATUS === 'OK') {
    return true;
  }

  if (DATA.STATUS === 'ERROR') {
    throw new Error(DATA);
  }
}

export default { get };
